export default __webpack_public_path__ + "static/media/avatar_74.23e89529.png";